export default "__VITE_ASSET__DzRrCKr6__"